import React from 'react';
import { Flyer } from '../components/Flyer';
export function FlyerPage() {
  return <Flyer data-id="element-797" />;
}